module.exports = __webpack_public_path__ + "static/media/snooze.0dc87b89.svg";